import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';

const CreateButton = ({ to, onClick }) => {
  return (
    <Link className="btn btn-fab" to={to} onClick={onClick}>
      <FiPlus size={22} />
    </Link>
  );
};

export default CreateButton;
